import { Link } from '@ksyos/design-system';
import { useLocation } from '@ksyos/router';
import { useNavigateInTabBar } from '@frontend/utils/hooks/useNavigateInTabBar';

export function NavigateToMonitoringTabLink(): JSX.Element {
    const { setSelectedTab } = useNavigateInTabBar();
    const { search } = useLocation();
    const searchParams = new URLSearchParams(search);
    const tab = 'monitoring';
    searchParams.set('tab', tab);

    return (
        <Link
            onClick={(event) => {
                event.preventDefault();
                setSelectedTab(tab);
            }}
            to={`?${searchParams.toString()}`}
            variant="link"
        >
            Ga naar monitoring tab
        </Link>
    );
}
